/**
 * ComingSoon — placeholder for nav destinations whose screens are not built yet.
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import '../features/feed/feed.css';

interface ComingSoonProps {
  /** i18n key for the feature name, e.g. 'home.tabs.buddies'. */
  titleKey: string;
}

export function ComingSoon({ titleKey }: ComingSoonProps) {
  const { t } = useTranslation();

  return (
    <section className="feed-empty" aria-label={t(titleKey)}>
      <h1 style={{ fontSize: 'var(--font-size-xl)', marginBottom: 'var(--space-2)' }}>
        {t(titleKey)}
      </h1>
      <p>{t('home.comingSoon')}</p>
    </section>
  );
}
